import React, { Suspense, lazy } from 'react';
import Navigation from '../../components/home/Navigation';
import Hero from '../../components/home/Hero';
import Features from '../../components/home/Features';
import TestimonialCarousel from '../../components/home/TestimonialCarousel';
import Footer from '../../components/home/Footer';

// Lazy load non-critical sections
const HowItWorks = lazy(() => import('../../components/home/HowItWorks'));
const Pricing = lazy(() => import('../../components/home/Pricing'));

// Memoize testimonials data
const testimonials = [
  {
    quote: "CashBitAI transformed how I manage my finances. The AI insights are incredibly accurate and helpful.",
    author: "Sarah Chen",
    role: "Product Manager at Google",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  },
  {
    quote: "The automated insights have helped me save an extra $500 monthly. It's like having a personal financial advisor.",
    author: "Marcus Johnson",
    role: "Software Engineer at Meta",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  },
  {
    quote: "Finally, a financial platform that makes sense! The interface is clean and the AI suggestions are spot-on.",
    author: "Emily Rodriguez",
    role: "Startup Founder",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop"
  }
];

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Navigation />
      <Hero />
      <Features />
      
      {/* Testimonials Section */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
              What Our Users Say
            </h2>
            <p className="mt-4 text-xl text-gray-600 dark:text-gray-300 mb-16">
              Join thousands of satisfied users
            </p>

            <TestimonialCarousel testimonials={testimonials} />
          </div>
        </div>
      </section>

      {/* Lazy loaded sections with loading fallback */}
      <Suspense fallback={
        <div className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="animate-pulse space-y-8">
              <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mx-auto"></div>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3 mx-auto"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="h-64 bg-gray-200 dark:bg-gray-700 rounded"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }>
        <HowItWorks />
        <Pricing />
      </Suspense>

      <Footer />
    </div>
  );
};

// Memoize the entire component
export default React.memo(Home);